<template>
    <div class="content-wrap">
                <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="리비전번호">
              <template #end>
                <ElSelect v-model="state.revSelect.selected" :options="state.revidList.map(item => ({text: item.rev_id, value: item.rev_id}))"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>
    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getList()">
        검색
      </ElButton>
    </div>
      <div class="table-responsive table-list">
        <TreeTable ref="treeTableRef" :data-list="state.originList" :grid-column="state.gridColumn"
          :root-val="''" />
      </div>
  
      <div class="text-end py-3">
        <!-- <ElButton
          type="primary"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          :disabled="true"
        >
          일괄등록
        </ElButton> -->
        <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
       
      </div>
  
      <!-- 모달 -->
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
  
      </div>
    </div>
  </template>
  
  <script setup>
  import { reactive, onMounted, ref } from "vue";
  import api from "@/utils/api";
  import routerCmn from "@/js/vueRouterCmn";
  
  import TreeTable from "@/components/common/TreeTable.vue";
  
  import common from '@/js/common';
  import { useUserStore } from '@/store/user'
  const userStore = useUserStore()
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { prodList, prodEdit, prodDelete, getProdRevIdList,prodRevClassInst } from "@/api/prod";
  
  const refInput = ref();
  const selectByCodeRef = ref();
  const treeTableRef = ref()
  
  
  onMounted(async () => {
    await getRevList();
  
    await getList();
  });
  const state = reactive({
    selectedKey: [],
    gridColumn: [
    {
      header: "상품명",
      field: "class_nm",
      expander: true,
      style: { width : '14%' },
      type: 'text'
    },
    { header: "활성화 여부", field: "enable_yn", type: 'select', cdGr: 'YN_CD', chkEss: 'Y', style: { width : '8%' }, bodyClass: 'text-center'},
    { header: "계약만료 필수입력대상", field: "applicable_yn", type: 'select', cdGr: 'YNA_CD', chkEss: 'Y', style: { width : '13%' }, bodyClass: 'text-center'},
    { header: "GPU 여부", field: "gpu_model_yn", type: 'select',cdGr: 'YN_CD', chkEss: 'N',style: { width : '9%' },bodyClass: 'text-center'},
    { header: "순번", field: "sort_ord", type: 'text', style: { width : '5%' }},
    { header: "등록일", field: "fmt_reg_dt", style: { width : '12%' }},
    { header: "등록자", field: "reg_user_nm", style: { width : '6%' }},
    { header: "수정일", field: "fmt_upd_dt", style: { width : '12%' }},
    { header: "수정자", field: "upd_user_nm", style: { width : '6%' }},
    { header: "메모", field: "note", type: 'text', style: { width : '13%' }},
  ],
    gridRowData: [],
    originList: [],
    clickIdx: "",
    updateData: [],
    maxDepth: 1,
    updateCheck: false,
    revidList: [],
    firstLoad: true,
    selectRows: [],
    maxRevid: "",
    revSelect: {
      selected: "",
      list: [],
    },
  });
  
  const getList = async () => {
    //상품분류체계 List api 호출
    // state.revidList.map((item) => {
    //   let rev_id = item.rev_id.substr(2);
    //   let maxrevIdVal = state.maxRevid.substr(2);
    //   if (rev_id > maxrevIdVal) {
    //     state.maxRevid = item.rev_id;
    //   }
    // });
  
    let params = {
      rev_id: state.revSelect.selected, // 리비전 ID 필수값
    };
    try {
      setIsLoading(true)
      const res = await prodList(params)
      state.originList = [...res.rtn]
      state.updateCheck = false;
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }
  
  //이전버튼 클릭
  const goBack = () => {
    if (state.updateCheck) {
      let msg = "저장되지 않은 데이터가 있습니다.뒤로 가시겠습니까?";
      if (confirm(msg)) {
        routerCmn.goBack();
      }
    } else {
      routerCmn.goBack();
    }
  };

  
 
  
  //리비전 목록 가져오기
  const getRevList = async () => {
    try {
      setIsLoading(true)
      const res = await getProdRevIdList()
      state.revidList = res.rtn;
      state.revSelect.selected = res.rtn[0].rev_id;
    } catch (err) {
      console.error(err)
      alert('리비전 정보를 불러오는데 실패했습니다.')
    } finally {
      setIsLoading(false)
    }
  };
  
  
  </script>
  